import dayjs from "dayjs";
import { getTemplateInitialValues } from "@/hooks/useTaskTemplate";

/**
 * Возвращает initial values формы задачи для двух сценариев:
 * - создание из шаблона
 * - редактирование/создание без шаблона (с данными задачи)
 * Чистая функция: не содержит побочных эффектов.
 */
export const getTaskInitialValues = (
  data,
  template,
  { defaultUnit, defaultStatus, defaultPriority, defaultTaskType, units = [] },
  todayDate
) => {
  if (!data?.uuid && template?.uuid) {
    return {
      ...getTemplateInitialValues(template, {
        defaultUnit,
        defaultStatus,
        defaultPriority,
        defaultTaskType,
        todayDate,
        units,
      }),
    };
  }

  return {
    ...data,
    start_date: data?.uuid
      ? data.start_date
        ? dayjs(data.start_date)
        : null
      : todayDate,
    due_date: data?.due_date ? dayjs(data.due_date) : null,
    status_uuid: data?.uuid ? data.status_uuid : defaultStatus.uuid,
    importance_uuid: data?.uuid ? data.importance_uuid : defaultPriority.uuid,
    task_type_uuid: data?.uuid ? data.task_type_uuid : defaultTaskType.uuid,
    unit_uuid: data?.unit_uuid || defaultUnit.uuid,
    coexecutors_uuids: data?.coexecutors
      ? data.coexecutors.map((item) => item.uuid)
      : [],
    is_accessible_for_all_in_unit: data?.is_accessible_for_all_in_unit || false,
    is_create_new_template: false,
  };
};
